import { bedP } from '../page/BedStatus/bsApp';

const handleGetBsCleansingType = (allData) => {
  if (allData?.[bedP.airbornePrecaution]) {
    return 'AIRBORNE_PRECAUTION';
  } else if (allData?.[bedP.dropletPrecaution]) {
    return 'DROPLET_PRECAUTION';
  } else if (allData?.[bedP.contactPrecaution]) {
    return 'CONTACT_PRECAUTION';
  } else if (allData?.[bedP.mdroInfo]?.length > 0) {
    return 'MDRO';
  } else if (allData?.[bedP.covidPositivePat]) {
    return 'COVID19';
  } else return '';
};

export default handleGetBsCleansingType;
